import { ChangeDetectionStrategy, Component, ElementRef, HostListener, contentChild, inject, input, output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { XpDialogHeaderComponent } from '../dialog-header/xp-dialog-header.component';

@Component({
	selector: 'xp-dialog',
	standalone: true,
	imports: [MatCardModule],
	templateUrl: './xp-dialog.component.html',
	styleUrls: ['./xp-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpDialogComponent {
	closeOnBackdrop = input(false);
	ariaLabel = input('');
	closed = output<void>();

	header = contentChild(XpDialogHeaderComponent);

	private readonly host: HTMLElement = inject(ElementRef).nativeElement;

	@HostListener('click', ['$event'])
	onClick(event: MouseEvent): void {
		if (this.closeOnBackdrop() && event.target === this.host) {
			this.closed.emit();
		}
	}
}
